module.exports = __webpack_public_path__ + "media/components/home/masthead/img/lavakidneys_530x400-176b31e5702f9c5c21eb5d0be43b988d.jpg";